/* unplugin-vue-components disabled */import { render } from "./AnswerQuestion2.vue?vue&type=template&id=49da7194&scoped=true"
import script from "./AnswerQuestion2.vue?vue&type=script&lang=js"
export * from "./AnswerQuestion2.vue?vue&type=script&lang=js"

import "./AnswerQuestion2.vue?vue&type=style&index=0&id=49da7194&scoped=true&lang=css"

import exportComponent from "/home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49da7194"]])

export default __exports__